<template>
  <div class="Debugger">  
    <div v-html="txt"/>
  </div>
</template>

<script>
import Settings from '@/config/Settings'
export default {
  name: 'Debugger',
  data: () => ({
    txt: '',
    count: 0,
    locked: false
  }),
  methods: {
    useDebugger(nw) {    
      this.count +=1
      this.txt = String(this.count) +' - *'
      if(this.count > 1 && this.$parent.ready == false) {
        if(this.locked)
          return
        this.locked = true
        const reload = this.$router.resolve({ query: { forceReload: undefined } })
        window.location.href = "https://"+ Settings.onfWebsite.prod[this.lang] +"/web/"+ reload.href
      }
      else if(this.count > 1){
        const time = this.$parent.$refs.timeline.getTime()
        if(time > 0) {
          const ctx = this.$parent.$refs.cta.getContext()
          if(ctx == 'play'){
            this.$parent.$refs.timeline.forceStoppped()
            this.$parent.$refs.cta.forceStoppped()
          }
        }
      }
    }
  },
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Debugger
  display flex
  position absolute 
  width 1vw
  height 1vh
  background rgba(black, .7)
  z-index 30000
  padding 16px
  font-size 12px
  pointer-events none 
  opacity 0

  .focus
    color green
    font-weight bold
 
  .blur
    color red
    font-weight bold

</style>

















